import request from "@/utils/request";
import {baseURL} from "@/utils/getawayModule";


/**
 * 根据KEY搜索模板
 * @param key
 * @returns {AxiosPromise}
 */
export function getTemplatesByKey(key) {
  return request({
    url: `${baseURL.businessApi}/templates/byKey?key=${key}`,
    method: 'get'
  })
}


/**
 * 修改模板
 * @param data
 * @param id
 * @returns {AxiosPromise}
 */
export function postTemplatesById(data, id) {
  return request({
    url: `${baseURL.businessApi}/templates/${id}`,
    method: 'post',
    data: data
  })
}



